"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const InputLabel_1 = require("./InputLabel");
const { root, outlined, error, focused, disabled } = InputLabel_1.inputLabelClasses;
const MuiInputLabelOverrides = {
    MuiInputLabel: {
        styleOverrides: {
            root: ({ theme }) => ({
                [`&.${root}`]: {
                    color: theme.palette.gray[800],
                },
                [`&.${outlined}.${disabled}`]: {
                    color: theme.palette.gray[500],
                },
                [`&.${outlined}.${error}`]: {
                    color: theme.palette.red[500],
                },
                [`&.${outlined}.${focused}:not(.${error})`]: {
                    color: theme.palette.gray[700],
                },
                [`&.${root}.${disabled}`]: {
                    color: theme.palette.gray[500],
                },
                [`&.${root}.${error}`]: {
                    color: theme.palette.red[500],
                },
            }),
        },
    },
};
exports.default = MuiInputLabelOverrides;
//# sourceMappingURL=MuiInputLabelOverrides.js.map